module.exports = __webpack_public_path__ + "img/sty_2.5d90167b.jpg";